import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";
import { iconPerAlertSeverityAndStatus } from "../../shared/riskIcons";

const intialStateMap = {
  pointsStore: null,
  filteredPointsStore: null,
  infoWindowContent: "",
  isFiltered: false,
  isPopup: 0,
  alertForAlertsTable: [],
  statusForSnackbar: 0,
  objectForTableFiltering: {
    beneficiaryId: null,
    alertScore: null,
    statusId:null
  },
};

const editMapState = (state, action) => {
  return updateObject(state, {
    ...action.payload,
  });
};

const editMapPoint = (state, action) => {

  const { alarm } = action.payload;

  const {
    beneficiaryId,
    riskFactorScore,
    statusId,
    assignmentDate,
    assignmentUser,
    specificAlarmForCompletion,
    specificAlarmForAssignment,
  } = alarm;

  let newAlertForAlertsTable = [...state.alertForAlertsTable];

  const filterAlarmsBySeverityAndDate = (alarms) => {
    let highAlarm, middleAlarm, lowAlarm;
    highAlarm = alarms.filter((alarm) => alarm.alarmSeverity === "High");
    middleAlarm = alarms.filter((alarm) => alarm.alarmSeverity === "Middle");
    lowAlarm = alarms.filter((alarm) => alarm.alarmSeverity === "Low");
    if (highAlarm.length !== 0) {
      return highAlarm[0];
    }
    if (middleAlarm.length !== 0) {
      return middleAlarm[0];
    }
    if (lowAlarm.length !== 0) {
      return lowAlarm[0];
    }
  };

  const filterAlarmsByStatus = (alarms) => {
    const openAlarms = alarms.filter((alarm) => alarm.statusId === 1);
    const pendingAlarms = alarms.filter((alarm) => alarm.statusId === 2);
    if (openAlarms.length > 0) {
      return filterAlarmsBySeverityAndDate(openAlarms);
    } else {
      return filterAlarmsBySeverityAndDate(pendingAlarms);
    }
  };

  const updatePointsStoreWithAlarms = () => {
    let points = [
      ...state.pointsStore.map((point) => {
        let index;
        if (point.beneficiaryId === beneficiaryId && statusId === 1) {
          point.alarms.unshift(alarm);
        }
        else if (point.beneficiaryId === beneficiaryId && statusId === 2) {
          if (specificAlarmForAssignment) {
            for (const id of specificAlarmForAssignment) {
              index = point.alarms.findIndex(alarm => alarm.id === id);
              point.alarms[index].statusId = 2;
              point.alarms[index].assignmentUser = assignmentUser;
              point.alarms[index].assignmentDate = assignmentDate;
            }
          }
        }

        else if (point.beneficiaryId === beneficiaryId && statusId === 3) {
          if (specificAlarmForCompletion) {
            for (const id of specificAlarmForCompletion) {
              index = point.alarms.findIndex(alarm => alarm.id === id);
              point.alarms.splice(index, 1);
            }
          }
        }

        if (point.alarms.length !== 0) {
          let highestAlarm = filterAlarmsByStatus(point.alarms);
          point.highestAlarmSeverity = highestAlarm.alarmSeverity;
          point.highestAlarmStatus = highestAlarm.statusId;
          point.highestAlarmDescription = highestAlarm.alarmType;
          point.iconUrl =  iconPerAlertSeverityAndStatus 
          (
            point.highestAlarmStatus,
            point.highestAlarmSeverity
          );
        } else {
          point.highestAlarmDescription = null;
          point.highestAlarmSeverity = null;
          point.highestAlarmStatus = 0;
          point.iconUrl = iconPerAlertSeverityAndStatus(null, null);
        }

        return point;
      }),
    ];
    return points;
  };

  return updateObject(state, {
    isPopup: riskFactorScore,
    statusForSnackbar: statusId,
    alertForAlertsTable: newAlertForAlertsTable,
    pointsStore: state.pointsStore ? updatePointsStoreWithAlarms() : null,
    filteredPointsStore: state.pointsStore,
  });
};

export const MapReducer = (state = intialStateMap, action) => {
  switch (action.type) {
    case actionTypes.EDIT_MAP_STATE:
      return editMapState(state, action);

    case actionTypes.EDIT_MAP_POINT:
      return editMapPoint(state, action);

    default:
      return state;
  }
};
